import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Divider,
  Button,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useNavigate } from "react-router-dom";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import styles from "../Mockexampage/MockGrid.module.scss";
import Avatars from "../../Components/Avatar/Avatars";
import { listSubjectNote } from "../../Redux/Slices/StudyNote/SubjectStudyNode";
import Mockexamimage from "../Mockexampage/Imagemockexampage/MockExamimage.jpg";
import { listListSubjectNoteTopicSlice } from "../../Redux/Slices/StudyNote/TopicStudyNode";

const cardData = [
  {
    title: "Quantitative Reasoning",
    subtitle:
      "Mathematical concepts, algebra, arithmetic, and problem-solving techniques",
    topics: 2,
    examples: 3,
    time: "1h study time",
    dotColor: "#2563EB", // blue
  },
  {
    title: "Reading Comprehension",
    subtitle: "Text analysis, inference, and critical reading strategies",
    topics: 1,
    examples: 1,
    time: "0h study time",
    dotColor: "#22C55E", // green
  },
  {
    title: "Abstract Reasoning",
    subtitle: "Pattern recognition, logical sequences, and spatial reasoning",
    topics: 1,
    examples: 1,
    time: "1h study time",
    dotColor: "#A855F7", // purple
  },
  {
    title: "Writing Skills",
    subtitle:
      "Essay structure, grammar, and effective communication techniques",
    topics: 1,
    examples: 1,
    time: "1h study time",
    dotColor: "#F97316", // orange
  },
];

const StudyGrid = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(listUser());
    dispatch(listSubjectNote());
  }, [dispatch]);
  const { data: ListSubjectNote } = useAppSelector(
    (state) => state.ListSubjectNoteSlice
  );
  const Subject: any = ListSubjectNote?.data;

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  return (
    <div className="ExamprocessStudentAlingment">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>
          <div className="DashboardStudent">Subject</div>
          <div className={styles.StudentPractice}>
            Comprehensive study materials organized by subject
          </div>
        </div>
        <div>
          <Menus
            menuItems={[
              // {
              //   menu: "Profile",
              //   onClick: () => {
              //     nav("/studentprofile");
              //   },
              // },
              {
                menu: "Logout",
                onClick: () => {
                  sessionStorage.clear();
                  dispatch(clearListuser());
                  dispatch(clearLoginStatus());
                  navigate("/login");
                },
              },
            ]}
          >
            <IconButtonField onClick={() => {}}>
              <Avatars sx={{ height: "2rem", width: "2rem" }} />
            </IconButtonField>
          </Menus>
          <span className="Username">{ListUser[0]?.student_name}</span>
        </div>
      </div>
      <Grid container spacing={3}>
        {Subject?.length > 0 ? (
          Subject?.map((card: any) => (
            <Grid item xs={12} sm={12} md={6} lg={3} key={card.id}>
              <Card className={styles.card} sx={{ boxShadow: "none" }}>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    height: "175px",
                  }}
                >
                  <img
                    src={card?.image_url}
                    alt="Mock Exam"
                    style={{
                      width: "100%",
                      height: "97%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                  />
                </div>

                <CardContent className={styles.cardBody}>
                  <div className={styles.mockexamname}>{card.name}</div>
                  <div
                    style={{
                      color: "#6b7280",
                      borderRadius: "20px",
                      fontSize: "12px",
                      padding: "5px 5px 0px 0px",
                    }}
                    title={`Sequence : ${card?.sequence}`}
                  >
                    Sequence: {card?.sequence}
                  </div>
                  {/* <div
                    style={{
                      color: "#6b7280",
                      borderRadius: "20px",
                      fontSize: "12px",
                      padding: "5px 0px",
                    }}
                    title={`Sequence : ${card?.sequence}`}
                  >
                    Year Level: {card.year_level}
                  </div> */}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="contained"
                      className={styles.startButton}
                      onClick={() => {
                        dispatch(
                          listListSubjectNoteTopicSlice({ sub_id: card?.id })
                        );
                        navigate("/topic", { state: card?.id }); // Replace with your target route
                      }}
                    >
                      Start Now
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card className={styles.card} sx={{ boxShadow: "none" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={Mockexamimage}
                  alt="Mock Exam"
                  style={{
                    width: "100%",
                    height: "97%",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                />
              </div>

              <CardContent className={styles.cardBody}>
                <div className={styles.mockexamname}>
                  {" "}
                  No study note Available
                </div>
                <Typography
                  variant="body2"
                  className={styles.mockexamndescription}
                >
                  Currently, there are no mock exams available at the moment.
                  Please check back soon for updates and new mock exams
                </Typography>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    className={styles.startButton}
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Back to home
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default StudyGrid;
